export default __webpack_public_path__ + "static/media/logo-us-torry.1b8e84c2.svg";